import { MAIN_SERVER } from './instance'
import { UTILS__VALIDATOR__is_value } from '../utils/validator'

export const GET_PROJECT_TYPES = async () => {
    try {
        return await MAIN_SERVER({
            method: 'get',
            url: `/types`,
        })
    } catch (err) {
        throw err
    }
}

export const GET_TEMPLATE = async templateId => {
    try {
        return await MAIN_SERVER({
            method: 'get',
            url: `/templates/${templateId}`,
        })
    } catch (err) {
        throw err
    }
}

export const GET_TEMPLATES = async obj => {
    try {
        const params = {}
        if (UTILS__VALIDATOR__is_value(obj.per_page)) {
            params.size = obj.per_page
        }
        if (UTILS__VALIDATOR__is_value(obj.offset_pages)) {
            params.page = obj.offset_pages
        }
        if (UTILS__VALIDATOR__is_value(obj.sort)) {
            params.sort = obj.sort
        }
        if (UTILS__VALIDATOR__is_value(obj.is_minimal)) {
            params.isMinimal = obj.is_minimal
        }

        return await MAIN_SERVER({
            method: 'get',
            url: `/templates`,
            params,
        })
    } catch (err) {
        throw err
    }
}

export const GET_TEMPLATES_CUSTOM_LIST = async obj => {
    try {
        const params = {}

        if (UTILS__VALIDATOR__is_value(obj.ids)) {
            params.ids = obj.ids.join(',')
        }

        return await MAIN_SERVER({
            method: 'get',
            url: `/templates/custom-list`,
            params,
        })
    } catch (err) {
        throw err
    }
}

export const GET_TYPE_TEMPLATES = async (obj, typeId) => {
    try {
        const params = {}
        if (UTILS__VALIDATOR__is_value(obj.per_page)) {
            params.size = obj.per_page
        }
        if (UTILS__VALIDATOR__is_value(obj.offset_pages)) {
            params.page = obj.offset_pages
        }
        if (UTILS__VALIDATOR__is_value(obj.sort)) {
            params.sort = obj.sort
        }
        if (UTILS__VALIDATOR__is_value(obj.is_minimal)) {
            params.isMinimal = obj.is_minimal
        }

        return await MAIN_SERVER({
            method: 'get',
            url: `/types/${typeId}/templates`,
            params,
        })
    } catch (err) {
        throw err
    }
}
